module.exports = __webpack_public_path__ + "static/img/sfzf.2872f7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spreader/sfzf.jpg
// module id = q8pz
// module chunks = 1